import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function DataPrivacy() {
  const { t } = useTranslation('home');

  return (
    <section className="py-16 bg-gradient-to-br from-slate-50 to-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
              <i className="ri-shield-check-line text-2xl text-teal-600"></i>
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                {t('dataPrivacy.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('dataPrivacy.description')}{' '}
                <a 
                  href="mailto:David@novaventure.be"
                  className="text-teal-600 hover:text-teal-700 font-medium underline decoration-teal-300 hover:decoration-teal-500 transition-colors"
                >
                  {t('dataPrivacy.email')}
                </a>
              </p>
              <Link 
                to="/privacy-policy"
                className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium transition-colors group"
              >
                <span>{t('dataPrivacy.learnMore')}</span>
                <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}